module.exports = __webpack_public_path__ + "static/img/cert3.0777c66.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cert3.png
// module id = o3Te
// module chunks = 1